import { render, staticRenderFns } from "./PProductPicker.vue?vue&type=template&id=0840a235"
import script from "./PProductPicker.vue?vue&type=script&lang=js"
export * from "./PProductPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports